/**
 * T2-3 판정 상태 — 감정인이 후보(AnalysisResult)에 기록하는 판단 5값.
 *
 * 검출/불검출 이분법 대신 (기획 v4 §8): 동정 / 부분적으로 부합 / 분류 불가 /
 * 자료 불충분 / 라이브러리 미평가. **사람 입력만** 기록되고 화면은 그것을
 * 보여줄 뿐 자동으로 판정을 만들지 않는다.
 */

export const ASSESSMENT_STATUS_LABEL: Record<string, string> = {
  identified: "동정",
  partially_consistent: "부분적으로 부합",
  not_classifiable: "분류 불가",
  insufficient_data: "자료 불충분",
  library_not_evaluated: "라이브러리 미평가",
};

const BADGE_CLS: Record<string, string> = {
  identified: "bg-green-100 text-green-800",
  partially_consistent: "bg-yellow-100 text-yellow-800",
  not_classifiable: "bg-orange-100 text-orange-800",
  insufficient_data: "bg-gray-100 text-gray-700",
  library_not_evaluated: "bg-slate-100 text-slate-700",
};

/** 미지 값은 중립(회색) — 안전해 보이게 칠하지 않는다. */
export function assessmentBadgeClass(status: string): string {
  return BADGE_CLS[status] ?? "bg-gray-200 text-gray-700";
}
